<script>
import { Icon } from 'svelte-icons-pack';
import { BiGasPump } from "svelte-icons-pack/bi";
import { BiDollarCircle } from "svelte-icons-pack/bi";
import  Tooltip  from './Tooltip.svelte';

export let gas;
export let ethPrice;
</script>

<h6>
  <Icon src={BiGasPump} size="20" color="CornflowerBlue"/>
  Gas Fees
</h6>

<Tooltip title="${(ethPrice * gas['gas_eth']).toFixed(2)} USD">
  <div style="font-size: 20px; display: inline; color: blue;">{gas['gas_eth'].toFixed(4)} 
    <p style="font-size: large; display: inline; margin: 0;">
      ETH<Icon src={BiDollarCircle} size="20" color="grey"/>
    </p>
  </div>
</Tooltip>

